import React from "react";
import { getDate } from "../../../helpers/utils";
import moment from "moment";

const ExchangeRateRow = ({ value, currency, id, created_at, date, baseCurrency = { symbol: "$" } }) => {

  return (
    <tr key={id}>
      <td className="align-middle">
        <b>
          {currency?.iso} {Number(value)?.toFixed(2)} = {baseCurrency?.symbol || "$"} 1
        </b>
      </td>
   <td className="align-middle">
  {date ? moment(date).format('DD/MM/YYYY') : ''}
</td>
      <td className="align-middle">
        {new Date(created_at).toLocaleDateString()}
      </td>
      
    </tr>
  );
};

export default ExchangeRateRow;
